import { DependencyList, EffectCallback, useEffect } from 'react'
import useIsFirstRender from './useIsFirstRender'

/**
 * modified version of useEffect skipping first render
 * @see https://usehooks-ts.com/react-hook/use-update-effect
 */
const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList) => {
  const isFirst = useIsFirstRender()

  useEffect(() => {
    if (!isFirst) {
      return effect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

export default useUpdateEffect
